import { render, staticRenderFns } from "./FirmOrderSummary.vue?vue&type=template&id=a74434aa&scoped=true"
import script from "./FirmOrderSummary.vue?vue&type=script&lang=js"
export * from "./FirmOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./FirmOrderSummary.vue?vue&type=style&index=0&id=a74434aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74434aa",
  null
  
)

export default component.exports